import {
  MonitorPriority,
  monitorPriorities,
} from "@p0security/shared/types/assessment/monitor";
import { Flex, Space, Typography } from "@p0security/ui";
import { priorityColor } from "components/Assessment/utils/monitor";
import { compact } from "lodash";
import { useMemo } from "react";
import { TooltipProps } from "recharts";
import {
  NameType,
  ValueType,
} from "recharts/types/component/DefaultTooltipContent";
import { colors } from "styles/variables";

import { ColorCodeIndicator } from "../common/ColorCodeIndicator";

const { Text } = Typography;

export const FindingGraphTooltip = ({
  active,
  payload,
  label,
}: TooltipProps<ValueType, NameType>) => {
  const data = useMemo(
    () =>
      compact(
        monitorPriorities.map((priority) =>
          payload?.find((d) => d.dataKey === priority)
        )
      ),
    [payload]
  );

  return active && payload && data.some((d) => d.value) ? (
    <Flex
      className="p-[10px]"
      gap={4}
      vertical
      /* eslint-disable-line react/forbid-component-props */ style={{
        backgroundColor: colors.neutral["00"],
      }}
    >
      <Text>{label}</Text>
      {data.map(
        (p) =>
          p && (
            <Space size="small" key={p.name}>
              <ColorCodeIndicator
                color={
                  p?.dataKey
                    ? priorityColor[p.dataKey as MonitorPriority].color
                    : ""
                }
                className="h-[1em]!"
              />
              <Text key={p.name}>{`${p.name}: ${p.value}`}</Text>
            </Space>
          )
      )}
    </Flex>
  ) : null;
};
